import { FC, useMemo } from 'react';
import { COMPANY_VIEW_TYPE } from '../../../../../data-models/view-config.data-model';
import { ViewModel } from '../../../../../models/view.model';
import { OverviewTable2 } from '../../OverviewTable2/OverviewTable2';
import { OverviewTable } from './OverviewTable';
import { RoundTrackerTable } from './RoundTrackerTable';

export const ViewTable: FC<{ id: string; view: ViewModel }> = ({ view }) => {
  const tableByViewType = useMemo(
    () => ({
      [COMPANY_VIEW_TYPE.PORTFOLIO_OVERVIEW]: OverviewTable,
      [COMPANY_VIEW_TYPE.RETURN_FORECAST]: OverviewTable,
      [COMPANY_VIEW_TYPE.RETURN_FORECAST_2]: OverviewTable2,
      [COMPANY_VIEW_TYPE.ROUND_TRACKER]: RoundTrackerTable,
    }),
    []
  );

  const Component = tableByViewType[view.companyViewType];

  return <Component key={view.id} view={view} />;
};
